import {
  Container,
  Row,
  Col,
  Button
} from "reactstrap"
import { Modal } from "antd"
import { useSelector, useDispatch } from "react-redux"
import { getProfile } from "store/auth/profile/profileSlice"
import ProfileEditForm from "./profileForm"
import MultiStepForm from "components/multiStepForm"

import { useEffect, useState } from "react"


const Profile = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const dispatch = useDispatch()
  const profile = useSelector((state) => state.Profile.profile)
  useEffect(() => {
    console.log('nepo')
    dispatch(getProfile())
  }, [dispatch])
  const formatDateFR = (isoString) => {
    if (!isoString) return null;
    const date = new Date(isoString);
    return date.toLocaleDateString("fr-FR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };
  return (
    <>
      <div className="page-content">
        <Container fluid>
          <div className="page-title-box">
            <Modal
              title="Edit Profile"
              open={isModalVisible}
              onCancel={handleCancel}
              footer={null}
            >
              <ProfileEditForm handleCancel={handleCancel} />
            </Modal>
            <div style={{
              borderRadius: '10px',
            }}>

              <Row style={{
                backgroundColor: '#F4F4F4',
                fontSize: '20px',
                fontWeight: '400',
                padding: '40px',
                borderRadius: '10px',
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
              }}>
                <Col lg={16} className="mx-auto">
                  {profile ? (
                    <Row gutter={16}>
                      <Col span={12}>
                        <p className="black-title"><strong>Nom :</strong> {profile.lastName}</p>
                        <p className="black-title"><strong>Prénom :</strong> {profile.firstName}</p>
                        <p className="black-title"><strong>Date de naissance :</strong> {profile?.dateOfBirth ? formatDateFR(profile.dateOfBirth) : "Non renseignée"}</p>
                        <p className="black-title"><strong>E-mail :</strong> {profile.email}</p>
                        <p className="black-title"><strong>Numéro de téléphone :</strong> {profile.phone}</p>
                      </Col>
                      <Col span={12}>
                        <p className="black-title"><strong>Nom d’utilisateur :</strong> {profile.username}</p>
                        <p className="black-title"><strong>Club actuel :</strong> {profile.currentClub}</p>
                        <p className="black-title"><strong>Poste :</strong> {profile.position}</p>
                        <p className="black-title"><strong>Niveau d expérience :</strong>
                          {profile.experienceLevel == 'Other' ? profile.experienceDetails : profile.experienceLevel}
                        </p>
                        <p className="black-title"><strong>Category :</strong> {profile?.category}</p>
                      </Col>

                    </Row>

                  ) : (
                    <p>Chargement des informations...</p>
                  )}
                </Col>
                <Row className="d-flex justify-content-end mt-3">
                  <Col xs="auto">
                    <Button onClick={showModal} className='custom-bg' >Modifier</Button>
                  </Col>
                </Row>
              </Row>
            </div>

          </div>

        </Container>
      </div>

    </>

  )

}

export default Profile
